import styles from "./SearchMemberListItemSkeleton.module.scss";

export const SearchMemberListItemSkeleton = () => {
    return (
        <li className={styles.memberDataListItem}>
            <div className={`skeleton ${styles.icon}`} style={{ width: 35, height: 35 }} />

            <div className={styles.info}>
                <div className={`skeleton ${styles.icon}`} style={{ width: 230, height: 15 }} />
            </div>

            <div className={styles.right}>
                <div className="skeleton" style={{ width: 180, height: 15 }} />
            </div>
        </li>
    );
};
